var exports = {
  "kL": "xa15a2ab7--14933a--container",
  "Uq": "xa15a2ab7--14933a--value",
  "XI": "xa15a2ab7--14933a--action",
  "q$": "xa15a2ab7--14933a--action-disabled",
  "LU": "xa15a2ab7--14933a--action-left",
  "iA": "xa15a2ab7--14933a--action-right",
};

module.exports = exports;
